import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=d09def0a&"
import script from "./MultiSelect.vue?vue&type=script&lang=ts&"
export * from "./MultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\rafael\\Github\\MultiSelect\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d09def0a')) {
      api.createRecord('d09def0a', component.options)
    } else {
      api.reload('d09def0a', component.options)
    }
    module.hot.accept("./MultiSelect.vue?vue&type=template&id=d09def0a&", function () {
      api.rerender('d09def0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MultiSelect/MultiSelect.vue"
export default component.exports